export default "__VITE_ASSET__DwOTdepv__";